/**
 * Utilities for rounding video resolutions to standard values for display.
 */

// Standard resolution pairs (short x long dimensions)
export const STANDARD_RESOLUTIONS = [
  { short: 240, long: 426 },
  { short: 360, long: 640 },
  { short: 480, long: 854 },
  { short: 540, long: 960 },
  { short: 720, long: 1280 },
  { short: 1080, long: 1920 },
  { short: 1440, long: 2560 },
  { short: 2160, long: 3840 },
];

export const ROUNDING_THRESHOLD = 150;

/**
 * Finds the closest standard resolution by matching both dimensions.
 * Returns the standard "short" dimension for labeling (e.g., 1080 for 1080p).
 * Works for both landscape and portrait videos.
 */
export function findStandardResolution(width: number, height: number): number {
  const short = Math.min(width, height);
  const long = Math.max(width, height);

  let closestLabel = short;
  let minDistance = ROUNDING_THRESHOLD;

  for (const standard of STANDARD_RESOLUTIONS) {
    const distance = Math.abs(short - standard.short) +
      Math.abs(long - standard.long);
    if (distance < minDistance) {
      minDistance = distance;
      closestLabel = standard.short;
    }
  }

  return closestLabel;
}
